module.exports = __webpack_public_path__ + "static/media/order_blu_inactive.bb32b76d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/order_blu_inactive.png
// module id = 1666
// module chunks = 0